/* eslint-disable */
import auth0 from 'auth0-js'
import router from '@/system/router'

import store from '@/system/store'

import { CHOOSE_CUSTOMER_PATH } from '@/features/auth/auth.router'
import { STORE_SELECTED_CUSTOMER, CLEAR_AUTH_DATA } from '@/system/store/action-types'
import { SET_AUTH } from '@/system/store/mutation-types'
import { GET_AUTH } from '@/system/store/getter-types'

const {
  VUE_APP_AUTH0_DOMAIN: domain,
  VUE_APP_AUTH0_CLIENT_ID: clientID,
  VUE_APP_AUTH0_REDIRECT_URI: redirectUri,
  VUE_APP_AUTH0_AUDIENCE: audience,
  VUE_APP_ENDPOINT: appUrl
}: {
  VUE_APP_AUTH0_DOMAIN: string,
  VUE_APP_AUTH0_CLIENT_ID: string,
  VUE_APP_AUTH0_REDIRECT_URI: string,
  VUE_APP_AUTH0_AUDIENCE: string,
  VUE_APP_ENDPOINT: string
} = process.env

export default class AuthService {
  auth0 = new auth0.WebAuth({
    domain,
    clientID,
    redirectUri,
    audience,
    responseType: 'token id_token'
  })


  async handleAuthentication () {
    const { accessToken: token, expiresIn, idTokenPayload } = await new Promise((resolve, reject) =>
      this.auth0.parseHash((err: any, authResult: any) => {
        if (err) return reject(err)
        return resolve(authResult)
      }))

    const { iss, aud, iat, exp, nonce, at_hash, ...user } = idTokenPayload

    user.customerId = user['https://wemeasure.com/customerId']
    user.isAgentUser = user['https://wemeasure.com/isAgentUser'] || false

    store.commit(SET_AUTH, {
      token,
      expiresAt: Date.now() + expiresIn * 1000,
      user
    })

    const customer = user.family_name || user.customerId
    const canSelectCustomer = user.isAgentUser

    if (canSelectCustomer) {
      await router.push({ path: CHOOSE_CUSTOMER_PATH })
      return
    }

    await store.dispatch(STORE_SELECTED_CUSTOMER, {
      uuid: customer,
      id: customer
    })
    router.replace('/')
  }

  login () {
    this.auth0.authorize()
  }

  public async logout () {
    await store.dispatch(CLEAR_AUTH_DATA)
    this.auth0.logout({
      clientID,
      returnTo: appUrl
    })
  }

  public isAuthenticated () {
    const { expiresAt } = store.getters[GET_AUTH]
    return Date.now() < expiresAt
  }
}
